import css from './External.module.scss'
import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { ICheckoutDetails, ICheckoutPayment, PaymentGateway, PaymentMethod } from 'meta/pages/checkout'

import Loader from 'components/Checkout/Steps/Loader'
import Img from 'components/Media/Img'
import { checkIfTransactionIsGoodsRelated } from 'components/Pages/PurchaseForm/Tickets/utils'
import { useCheckoutDetails, useCheckoutPayment } from 'hooks/useCheckout'
import { usePosBankRedirectUrl } from 'hooks/useEnv'

import { addComingFromGSFastCheckoutToRoutePath } from '../utils'

const External: React.FC = () => {
  const { t } = useTranslation()
  const { gateway, gatewayData, methodCurrent } = useCheckoutPayment() as ICheckoutPayment
  const details = useCheckoutDetails() as ICheckoutDetails

  const { insideIFrame } = details

  const submitBtnRef = useRef<HTMLInputElement>(null)
  const posBankRedirectUrl = usePosBankRedirectUrl()

  const comingFromGSFastCheckout = Boolean(
    !details.needAuth &&
    details?.eventDetails &&
    details?.eventDetails.policyResponse &&
    checkIfTransactionIsGoodsRelated(details?.eventDetails.policyResponse?.code)
  )

  const getRedirectUrl = (): string => {
    // nexi with google pay / apple pay
    if (methodCurrent && [PaymentMethod.applePay, PaymentMethod.googlePay].includes(methodCurrent)) {
      return addComingFromGSFastCheckoutToRoutePath(gatewayData?.['hostedPage'] as string, comingFromGSFastCheckout)
    }

    switch (gateway) {
      case PaymentGateway.virtualPay:
        return addComingFromGSFastCheckoutToRoutePath(posBankRedirectUrl, comingFromGSFastCheckout)
      case PaymentGateway.nexi:
        return addComingFromGSFastCheckoutToRoutePath(gatewayData?.['hostedPage'] as string, comingFromGSFastCheckout)
      case 'PAYPAL':
        return addComingFromGSFastCheckoutToRoutePath(
          gatewayData?.['paypalRedirectUrl'] as string,
          comingFromGSFastCheckout
        )
      case 'SCALAPAY':
        return addComingFromGSFastCheckoutToRoutePath(
          gatewayData?.['checkoutUrl'] as string as string,
          comingFromGSFastCheckout
        )
    }
    throw new Error(`redirect url not found for gateway ${gateway}`)
  }
  const redirectUrl = getRedirectUrl()
  const formMethod = gateway === 'SCALAPAY' ? 'GET' : 'POST'

  useEffect(() => {
    setTimeout(() => {
      submitBtnRef.current?.click()
    }, 2000)
  }, [])

  return (
    <Loader>
      <div className={css.checkout_steps_external_container}>
        <div className={css.title}>
          {gateway === PaymentGateway.virtualPay && t('checkout:redirect_to_bank_site')}
          {gateway === 'PAYPAL' && t('checkout:redirect_to_paypal_site')}
          {gateway === 'SCALAPAY' && t('checkout:redirect_to_scalapay_site')}

          {gateway !== PaymentGateway.virtualPay &&
            gateway !== 'PAYPAL' &&
            gateway !== 'SCALAPAY' &&
            t('checkout:redirect_to_external_site')}
        </div>

        <div className={css.enable_popup_warning}>
          <div>{t('checkout:enable_popup_warning')}</div>
          <Img src="/icons/new_popup_icon.png" />
        </div>

        <div className={css.form}>
          <form method={formMethod} action={redirectUrl} target={insideIFrame ? '_parent' : '_self'}>
            <input ref={submitBtnRef} type="submit" />
            {gatewayData &&
              Object.keys(gatewayData).map((elem, key) => {
                return <input key={key} type="hidden" name={elem} value={gatewayData[elem]} />
              })}
            {comingFromGSFastCheckout && <input type="hidden" name="comingFromGSFastCheckout" value="true" />}
          </form>
        </div>
      </div>
    </Loader>
  )
}

export default External
